import { render } from "./guidlinesPage.vue?vue&type=template&id=5431493e&scoped=true"
import script from "./guidlinesPage.vue?vue&type=script&lang=js"
export * from "./guidlinesPage.vue?vue&type=script&lang=js"

import "./guidlinesPage.vue?vue&type=style&index=0&id=5431493e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5431493e"]])

export default __exports__